<template>
  <PageShell active="products">
    <section class="products-page">
      <div class="breadcrumb"><i class="el-icon-house"></i><span>&gt;</span><span>Popular products</span></div>
      <h1>Popular products</h1>
      <div v-if="loading" style="text-align:center;padding:40px 0;color:#999;">Loading...</div>
      <div class="product-grid" v-else>
        <article v-for="(product, index) in paginatedProducts" :key="index" class="product-card">
          <img :src="product.image_url" :alt="product.part_number" class="product-image">
          <div class="product-info">
            <div class="product-name">{{ product.part_number }}</div>
            <div class="product-desc">{{ product.name }}</div>
            <div class="product-buy">
              <strong>${{ product.price }}</strong>
              <button type="button" @click="addToCart(product)">
                <img src="@/assets/cart.png" alt="cart">
              </button>
            </div>
          </div>
        </article>
      </div>
      <div v-if="!loading && productList.length === 0" style="text-align:center;padding:40px 0;color:#999;">
        No products found.
      </div>
      <div class="pagination">
        <span>Total {{ total }} item</span>
        <!-- <span>每页</span>
        <select v-model.number="pageSize" @change="onPageSizeChange">
          <option :value="10">10</option>
        </select>
        <span>条</span> -->
        <select v-model.number="pageSize" @change="onPageSizeChange">
          <option :value="10">10</option>
        </select><span>items per page</span> 


        <button type="button" @click="goToPage(currentPage - 1)" :disabled="currentPage <= 1">&lt;</button>
        <template v-for="(page, index) in pageNumbers">
          <span v-if="page === '...'" :key="'ellipsis-' + index">...</span>
          <button v-else :key="page" :class="{ active: page === currentPage }" type="button" @click="goToPage(page)">{{
            page }}</button>
        </template>
        <button type="button" @click="goToPage(currentPage + 1)" :disabled="currentPage >= totalPages">&gt;</button>
        <!-- <span>前往</span>
        <el-input v-model="jumpPage" class="jump-input" @keyup.enter.native="handleJump" />
        <span>页</span> -->


        <span>Go to page</span>
        <el-input v-model="jumpPage" class="jump-input" @keyup.enter.native="handleJump" />

      </div>
    </section>
  </PageShell>
</template>

<script>
import PageShell from '@/components/common/PageShell.vue'
import { getToken } from '@/util/token-util.js'

export default {
  name: 'ProductListPage',
  components: {
    PageShell
  },
  data() {
    return {
      productList: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      jumpPage: ''
    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.total / this.pageSize))
    },
    paginatedProducts() {
      const start = (this.currentPage - 1) * this.pageSize
      return this.productList.slice(start, start + this.pageSize)
    },
    pageNumbers() {
      const pages = []
      const total = this.totalPages
      const current = this.currentPage
      if (total <= 7) {
        for (let i = 1; i <= total; i++) pages.push(i)
      } else {
        pages.push(1)
        if (current > 4) pages.push('...')
        const start = Math.max(2, current - 1)
        const end = Math.min(total - 1, current + 1)
        for (let i = start; i <= end; i++) pages.push(i)
        if (current < total - 3) pages.push('...')
        pages.push(total)
      }
      return pages
    }
  },
  mounted() {
    this.loadProducts()
  },
  methods: {
    async loadProducts() {
      this.loading = true
      try {
        const res = await this.$api({
          url: 'Catalog/partList',
          method: 'get',
          params: {
            page: this.currentPage,
            page_size: this.pageSize
          }
        })
        const items = res.data?.items || []
        this.productList = items
        this.total = this.productList.length
        this.currentPage = 1
      } catch (e) {
        this.$message.error('Failed to load products')
      } finally {
        this.loading = false
      }
    },
    goToPage(page) {
      if (page < 1 || page > this.totalPages) return
      this.currentPage = page
    },
    onPageSizeChange() {
      this.currentPage = 1
    },
    handleJump() {
      const page = parseInt(this.jumpPage)
      if (!isNaN(page)) {
        this.goToPage(page)
        this.jumpPage = ''
      }
    },
    async addToCart(product) {
      if (!getToken()) {
        this.$message.warning('Please log in first')
        this.$router.push({ name: 'home' })
        return
      }
      try {
        await this.$api({
          url: 'Cart/add',
          method: 'post',
          data: { part_id: product.id, quantity: 1 }
        })
        this.$message.success('Added to cart')
        this.$root.$emit('cart-updated')
      } catch (e) {
        this.$message.error('Failed to add to cart')
      }
    }
  }
}
</script>

<style scoped>
.products-page {
  max-width: 1100px;
  margin: 0 auto;
  padding: 24px 20px 58px;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 9px;
  color: #999;
  font-size: 13px;
}

.breadcrumb i {
  color: #F34B01;
}

h1 {
  margin: 28px 0 24px;
  color: #222;
  font-size: 20px;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 44px 14px;
}

.product-card {
  border: 1px solid #e5e5e5;
  min-width: 0;
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.product-card:hover {
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
}

.product-card:hover .product-image {
  transform: scale(1.08);
}

.product-card img {
  width: 100%;
  aspect-ratio: 1 / 1;
  display: block;
  object-fit: cover;
  background: #f7f7f7;
  overflow: hidden;
  border-bottom: 1px solid #e5e5e5;
  transition: transform 0.2s ease;
}

.product-info {
  padding: 0 12px 12px;
}

.product-name {
  margin-top: 20px;
  color: #F34B01;
  font-size: 16px;
  font-weight: 700;
}

.product-desc {
  margin-top: 12px;
  color: #999;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-buy {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.product-buy strong {
  color: #222;
  font-size: 16px;
}

.product-buy button {
  width: 24px;
  height: 24px;
  border: 0;
  background: #F34B01;
  color: #fff;
  cursor: pointer;
}

.pagination {
  margin-top: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
  color: #999;
  font-size: 13px;
}

.pagination button,
.pagination select {
  border: 1px solid #ddd;
  background: #fff;
  color: #999;
  height: 24px;
}

.pagination button {
  min-width: 24px;
  cursor: pointer;
  border-color: transparent;
}

.pagination button.active {
  color: #F34B01;
}

.pagination .jump-input {
  width: 44px;
}

.pagination .jump-input ::v-deep .el-input__inner {
  height: 24px;
  border: 1px solid #ddd;
  background: #fff;
  color: #999;
  text-align: center;
  padding: 0;
}

@media (max-width: 980px) {
  .product-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 620px) {
  .product-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .pagination {
    flex-wrap: wrap;
  }
}
</style>
